import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import type {
  FinancialSnapshotLoadResult,
  FinancialSnapshotPatchBody,
  FinancialSnapshotPostBody,
  FinancialSnapshotResponse,
  FinancialSnapshotTemplate,
} from './financial-snapshot.model';

/**
 * Seam for Financial Snapshot API. Store + UI depend only on this token.
 * `provideFinancialSnapshot()` binds the live Http implementation; tests may replace the token.
 */
export interface FinancialSnapshotApi {
  getTemplate(): Observable<FinancialSnapshotTemplate>;
  getSnapshot(guid: string): Observable<FinancialSnapshotLoadResult>;
  postSnapshot(body: FinancialSnapshotPostBody): Observable<FinancialSnapshotResponse>;
  patchCategory(guid: string, body: FinancialSnapshotPatchBody): Observable<FinancialSnapshotResponse>;
  /** POST /financialsnapshot/invite — Intercom send for the active client. */
  inviteClient(guid: string): Observable<void>;
}

export const FINANCIAL_SNAPSHOT_API = new InjectionToken<FinancialSnapshotApi>('FINANCIAL_SNAPSHOT_API');
